import { useEffect } from 'react';
import { LoginPage } from '../components/LoginPage';
import { ClinicLayout } from './ClinicLayout';
import { carryRestart } from './useClinicTesting';

/** What a visitor without a session sees: the clinic page, then the portal's sign-in. */
export function ClinicSignInPage({
  oauthError = null,
}: {
  oauthError?: string | null;
}) {
  useEffect(carryRestart, []);
  return (
    <ClinicLayout>
      <div className="mx-auto flex w-full max-w-md flex-col gap-4">
        <header className="flex flex-col gap-1.5 px-1">
          <h2 className="text-ink text-2xl font-semibold">
            Start your application
          </h2>
          <p className="text-muted text-base">
            New to FTLO? You can use your preferred email.
          </p>
        </header>
        {/* Re-points the portal's focus and input-edge colour to the clinic teal. */}
        <div className="[--mantine-color-brand-7:var(--color-deep)]">
          <LoginPage
            accent="deep"
            oauthError={oauthError}
            onLoggedIn={() => window.location.assign(window.location.pathname)}
          />
        </div>
      </div>
    </ClinicLayout>
  );
}
